import styled from 'styled-components';
import { BodyBoldS, LabelRegularM } from '../../../styles/globals';

export const ContentCont = styled.div`
  ${({ theme }) => `
    display: flex;
    gap: ${theme.layout.spacing.centy};

    @media ${theme.layout.breakpoints.max.tablet} {
      flex-flow: column nowrap;
    }
  `};
`;

export const SuggestionCard = styled.div`
  ${({ theme }) => `
    display: flex;
    padding: ${theme.layout.spacing.tera} ${theme.layout.spacing.centy} ${theme.layout.spacing.deka};
    flex: 1;
    background: ${theme.colors.neutral.primary[5]};
    border-radius: 8px;
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
  `};
`;

export const InngerCont = styled.div`
  ${({ theme }) => `
    position: relative;
    display: flex;
    width: 100%;
    padding: ${theme.layout.spacing.giga} ${theme.layout.spacing.deka} ${theme.layout.spacing.centy};
    flex-flow: column nowrap;
    gap: ${theme.layout.spacing.decy};
    background: ${theme.colors.neutral.primary[0]};
    border-radius: 8px;
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
  `};
`;

export const IconCont = styled.div`
  ${({ theme }) => `
    position: absolute;
    width: 80px;
    height: 80px;
    top: -40px;
    left: calc(50% - 40px);
    background: ${theme.colors.neutral.primary[0]};
    border: 4px solid ${theme.colors.neutral.primary[5]};
    border-radius: 50%;
  `};
`;

export const Icon = styled.img`
  ${({ theme }) => `
    padding: calc(${theme.layout.spacing.centy} + ${theme.layout.spacing.nano});
  `};
`;

export const Title = styled(BodyBoldS)`
  min-height: 48px;
  text-align: center;
`;

export const Description = styled(LabelRegularM)``;
